import collecting from "./collecting";
import layout from "./layout";
import loginPage from "./loginPage";
import page from "./page";
import project from "./project";
import resource from "./resource";
import subscriptions from "./subscriptions";
import text from "./text";

export default `
  ${collecting}
  ${layout}
  ${page}
  ${project}
  ${text}
  ${subscriptions}
  ${resource}
  ${loginPage}
`;
